import React from 'react'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { Redirect } from 'react-router-dom'
import { scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { Animation, Page, PageIntro } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
import { withChapter } from '@brainstud/react-tbl/themes/pgw/v1/containers'
import IntroType from '@brainstud/react-tbl/features/chapters/views/chapter/intro'

class ChapterIntroView extends React.Component {
  // TODO set theme
  componentDidMount() {
    scrollTop()

    this.setTheme()
    this.props.app.setBackground(this.props.chapter.background, this.props.chapter.backgroundStyle)
    this.props.app.setLocation({ label: 'intro', id: this.props.chapter.id })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.chapter !== this.props.match.params.chapter) {
      this.setTheme()
      scrollTop()
      this.props.app.setBackground(this.props.chapter.background, this.props.chapter.backgroundStyle)
    }
  }

  setTheme() {
    this.props.app.triggerTheme(this.props.chapter.navigation.theme || 'default')
  }

  handleHome = e => {
    this.props.history.push(Routes.to('home'))
  }

  handleContinue = e => {
    this.props.setNavigationProgress({
      id: this.props.chapter.navigation.id,
      data: {
        ...this.props.chapter.navigation.progress,
        progress: 1,
      }
    })
    this.props.app.willProgress(this.props.chapter.navigation.prefix)

    this.props.history.push(this.props.chapter.lessons[0].url)
  }

  render() {
    const { chapter } = this.props

    if(!chapter) {
      return <Redirect to={Routes.to('home')} />
    }

    return (
      <Page name="Intro" theme={this.props.app.theme}>
        <Animation name="slideInDown" delay={100}>
          <PageIntro
            title={chapter.title}
            description={chapter.description}
            progress={chapter.navigation.progress}
            chapter={chapter}
            continueButtonLabel={translate('card.start')}
            handleHome={this.handleHome}
            handleContinue={this.handleContinue}>
            <IntroType type={chapter.type} {...this.props} />
          </PageIntro>
        </Animation>
      </Page>
    )
  }
}

export default withChapter(ChapterIntroView)
